<template>
    <v-app id="autenticar">
        <v-container d-fluid id="autenticar_ceritificado">
            <v-row no-gutters class="d-flex justify-space-between">
                <v-col cols="12" sm="12" md="12" lg="12" xl="12">

                    <v-card class="elevation-3 pa-3">
                        <v-card-title class="text-center justify-center">
                            <div>
                                <v-img src="@/assets/image/logo-gobierno.png" contain width="340px" height="auto" alt="Gobierno de la República de Honduras · INFOP"></v-img>
                                <h3 class="my-4 primary--text">AUTENTICAR CONSTANCIA</h3>
                            </div>
                        </v-card-title>
                        <v-card-text>
                            <template v-if="typeof this.token !== 'undefined'">
                                <template v-if="this.estado == 'success'">
                                    <v-alert type="success" dense class="mb-3 text-uppercase">
                                        Constancia Autenticada
                                    </v-alert>

                                    <div class="border">
                                        <v-chip color="info">Constancia</v-chip>
                                        <div>{{ data.constancia_codigo }}</div>
                                    </div>
                                    <v-divider class="mb-2"></v-divider>

                                    <div class="border">
                                        <v-chip color="info">Nombre del Participante:</v-chip>
                                        <div>{{ data.nombre_participante }}</div>
                                    </div>
                                    <v-divider class="mb-2"></v-divider>

                                    <div class="border">
                                        <v-chip color="info">Número de Identidad:</v-chip>
                                        <div>{{ data.numero_identidad }}</div>
                                    </div>
                                    <v-divider class="mb-2"></v-divider>

<!--h2 class="text-lg font-bold mb-2">Cursos</h2-->
<v-chip color="info">Cursos:</v-chip>
<hr role="separator" aria-orientation="horizontal" class="mb-2 v-divider theme--light" style="border-width:0 0 0 0;">
<table class="table-auto w-full border border-gray-300" style="border-collapse: collapse;">
  <thead class="bg-gray-100">
    <tr style="background-color:#f0f0f0; border-bottom: 1px solid #ccc;">
      <th class="border px-2 py-1">Nombre del Curso</th>
      <th class="border px-2 py-1">Promoción</th>
      <th class="border px-2 py-1">Nota</th>
      <th class="border px-2 py-1">Horas</th>
      <!--th class="border px-2 py-1">Registro</th-->
      <th class="border px-2 py-1">Fecha Inicio</th>
      <th class="border px-2 py-1">Fecha Finalización</th>
      <!--th class="border px-2 py-1">Tutor</th-->
      <!--th class="border px-2 py-1">Año</th-->
    </tr>
  </thead>
  <tbody>
    <tr
      v-for="(curso, index) in data.cursos"
      :key="index"
      :style="{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f0f0f0' }"
    >
      <td style="border-bottom: 1px solid #ccc; white-space: nowrap; ">{{ curso.nombre_curso }}</td>
      <td style="border-bottom: 1px solid #ccc; text-align: center;">{{ curso.promocion }}</td>
      <td style="border-bottom: 1px solid #ccc; text-align: center;">{{ curso.nota }}</td>
      <td style="border-bottom: 1px solid #ccc; text-align: center;">{{ curso.horas }}</td>
      <!--td style="border-bottom: 1px solid #ccc; ">{{ curso.registro }}</td-->
      <td style="border-bottom: 1px solid #ccc; text-align: center;">{{ curso.fecha_inicio }}</td>
      <td style="border-bottom: 1px solid #ccc; text-align: center;">{{ curso.fecha_finalizacion }}</td>
      <!--td style="border-bottom: 1px solid #ccc; ">{{ curso.nombre_tutor }}</td-->
      <!--td style="border-bottom: 1px solid #ccc; ">{{ curso.anyo }}</td-->
    </tr>
  </tbody>
</table>

                                    <!--
                                    <h2 class="text-lg font-semibold mb-2"><bold>Cursos</bold></h2>
                                    <table class="table-auto w-full border border-gray-300">
                                    <thead class="bg-gray-100">
                                        <tr>
                                        <th class="border px-2 py-1">Nombre del Curso</th>
                                        <th class="border px-2 py-1">Promoción</th>
                                        <th class="border px-2 py-1">Nota</th>
                                        <th class="border px-2 py-1">Horas</th>
                                        <th class="border px-2 py-1">Registro</th>
                                        <th class="border px-2 py-1">Fecha Inicio</th>
                                        <th class="border px-2 py-1">Fecha Finalización</th>
                                        <th class="border px-2 py-1">Tutor</th>
                                        <th class="border px-2 py-1">Año</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(curso, index) in data.cursos" :key="index">
                                        <td class="border px-2 py-1">{{ curso.nombre_curso }}</td>
                                        <td class="border px-2 py-1">{{ curso.promocion }}</td>
                                        <td class="border px-2 py-1">{{ curso.nota }}</td>
                                        <td class="border px-2 py-1">{{ curso.horas }}</td>
                                        <td class="border px-2 py-1">{{ curso.registro }}</td>
                                        <td class="border px-2 py-1">{{ curso.fecha_inicio }}</td>
                                        <td class="border px-2 py-1">{{ curso.fecha_finalizacion }}</td>
                                        <td class="border px-2 py-1">{{ curso.nombre_tutor }}</td>
                                        <td class="border px-2 py-1">{{ curso.anyo }}</td>
                                        </tr>
                                    </tbody>
                                    </table>
                                    -->



                                </template>
                                <template v-if="this.estado == 'error'">
                                    <v-alert type="error">{{ mensaje }}</v-alert>
                                </template>
                            </template>
                            <template v-else>
                                <v-alert type="error">No se puede Autenticar sin el parametro de seguridad. Escanea
                                    nuevamente el Código QR en el Certificado.
                                </v-alert>
                            </template>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>

</template>

<script>

export default {
    name: 'AUtenticarConstancia',
    data() {
        return {
            loading: false,
            data: {},
            token: this.$route.query.token,
            mensaje: "",
            estado: null
        }
    },
    methods: {

        autenticar() {

            if (typeof this.token !== "undefined") {

                this.loading = true;

                let params = {
                    token: this.token
                };

                window.axios.get('/constancias/autenticar', {params}).then(async response => {
                    if (response.data.success == true) {
                        this.data = response.data.data;
                        this.estado = "success";

                    } else if (response.data.success === false) {

                        this.mensaje = response.data.message;
                        this.estado = "error";
                    }
                })
                    .catch(error => {
                        console.log(error)
                        this.estado = "error";
                        this.mensaje = "No se pudo Autenticar";
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            }
        },
    },
    created() {
        this.autenticar();
    }
}

</script>

<style src="./Autenticar.scss" lang="scss"/>
